// бургер

function burgerBtn () {
  const ButtonBurger = document.getElementById('burger');
  const menuMobile = document.querySelector('.nav-menu--mobile');

  ButtonBurger.addEventListener('click', function () {
    this.classList.toggle('true');
    menuMobile.classList.toggle('true')

  })
}

export  {
  burgerBtn
}
